// extracted by mini-css-extract-plugin
module.exports = {"dialogContact":"DialogRepurchaseDeposit_dialogContact_3ldjl"};